export const validaCnpj = (rule, value, callback) => {
  let i = 0
  const cnpj = value.replace(/\D/g, '')
  const pattern = /^(\d{1})1{13}$/
  let soma = 0
  let multiplicador = ''
  let digitoUm = ''
  let digitoDois = ''

  if (cnpj.length !== 14) {
    callback(new Error('O CNPJ deve ter 14 digitos'))
  }

  if (pattern.test(cnpj)) {
    callback(new Error('O CNPJ não atende as regras necessárias'))
  }

  for (i = 0; i < 12; i += 1) {
    multiplicador = (i <= 3 ? 5 : 13) - i

    soma += parseInt(cnpj.charAt(i), 10) * multiplicador
  }

  soma = soma % 11

  if (soma === 0 || soma === 1) {
    digitoUm = 0
  } else {
    digitoUm = 11 - soma
  }

  if (parseInt(digitoUm, 10) === parseInt(cnpj.charAt(12), 10)) {
    soma = 0

    for (i = 0; i < 13; i += 1) {
      multiplicador = (i <= 4 ? 6 : 14) - i
      soma += parseInt(cnpj.charAt(i), 10) * multiplicador
    }

    soma = soma % 11

    if (soma === 0 || soma === 1) {
      digitoDois = 0
    } else {
      digitoDois = 11 - soma
    }
    if (digitoDois === parseInt(cnpj.charAt(13))) {
      callback()
    }
  }

  callback(new Error('O CNPJ é inválido'))
}



// WEBPACK FOOTER //
// ./src/validators/cnpj.js